import * as yup from 'yup';

/**
 * E44 · the app lock — the both-ends input codecs of the two mutations (plan 03 §2.1 #3): the phone (before it sends)
 * and — as the shield's inputRule — the API run the SAME schema. Shape only: whether the timeout is one of the offered
 * four is the decider's (APP_LOCK_TIMEOUT_INVALID — the board's code, in the person's language), so the codec lets it
 * through.
 * `subject` is never on the wire: the caller is the subject.
 */

/** The installation's id the phone mints once: `<platform>-<hex>` (`ios-7f3a9c21`). */
export const appLockDeviceIdSchema = yup
  .string()
  .trim()
  .matches(/^(ios|android)-[0-9a-f]{8,32}$/)
  .required();

export const enableAppLockInputSchema = yup.object({
  deviceId: appLockDeviceIdSchema,
  method: yup
    .string()
    .trim()
    .oneOf(['faceId', 'touchId', 'fingerprint', 'iris', 'biometric', 'passcode'])
    .required(),
  // the offered set (0 · 1 · 5 · 15) is the decider's coded refusal; a sane integer range stops abuse
  lockAfterMinutes: yup.number().integer().min(0).max(1440).required(),
});

export const disableAppLockInputSchema = yup.object({
  deviceId: appLockDeviceIdSchema,
});

/** The mutation ARGUMENTS — what the shield's inputRules validate. */
export const enableAppLockArgsSchema = yup.object({
  input: enableAppLockInputSchema.required(),
});
export const disableAppLockArgsSchema = yup.object({
  input: disableAppLockInputSchema.required(),
});
export const appLockArgsSchema = yup.object({
  deviceId: appLockDeviceIdSchema,
});

export const appLockValidators = {
  enableAppLockInputSchema,
  disableAppLockInputSchema,
  enableAppLockArgsSchema,
  disableAppLockArgsSchema,
  appLockArgsSchema,
};
